module.exports = __webpack_public_path__ + "img/PL00161.4cc32882.png";